import { useEffect, useState } from 'react';
import { MdCancel } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import useUserInfo from '../../hooks/useUserInfo';
import { useAssignmentSubmitMutation } from '../../redux/features/assignment/assignmentApi';
import { addNotification } from '../../redux/features/notification.js/notificationSlice';

export default function AssignmentSubmit({ handleOut, assignment }) {
    const user = useUserInfo();
    const dispatch = useDispatch();
    const [input, setInput] = useState("")
    const [assignmentSubmit, { isLoading, isSuccess, isError }] = useAssignmentSubmitMutation();


    const changeHandler = (e) => {
        setInput(e.target.value)
    }


    const handleSubmit = (event) => {
        event.preventDefault();
        if (window.confirm("Do you want to submit assignment?")) {

            assignmentSubmit({
                student_id: user?.id,
                student_name: user?.name,
                assignment_id: assignment?.id,
                title: assignment?.title,
                totalMark: assignment?.totalMark,
                createdAt: new Date().toISOString(),
                repo_link: input.trim(),
                mark: 0,
                status: "pending"
            })
        } else {
            console.log("Form submission cancelled");
        }
    }

    // if successfully 
    useEffect(() => {
        if (isSuccess) {
            handleOut()
            dispatch(addNotification({
                message: "Assignment submitted successfully",
                type: "success"
            }))
        } else if (isError) {
            dispatch(addNotification({
                message: "Assignment submission failed. Try again",
                type: "rejected"
            }))
        }
    }, [dispatch, handleOut, isError, isSuccess])


    return (
        <div className="w-full p-1">
            <div className="w-full p-3 flex justify-between items-center">
                <div className='text-2xl font-bold text-cyan'>এসাইনমেন্ট জমা দিন</div>
                <div onClick={handleOut} className='p-2 cursor-pointer'><MdCancel /></div>
            </div>
            <div className='flex flex-col gap-2 p-4 my-3'>
                <div className='font-bold'>{assignment?.title}</div>
                <div>Total Mark- <span className='font-bold'>{assignment?.totalMark}</span></div>
            </div>
            <div className='p-4'>
                <form className='flex flex-col gap-3' onSubmit={handleSubmit}>
                    <label htmlFor='repo_link'>
                        গিটহাব রিপোসিটরি লিঙ্ক <span className='text-red-600'>*</span></label>
                    <input name="repo_link" type="text" required className="repo-input rounded"
                        value={input}
                        onChange={changeHandler}
                    />
                    <button disabled={isLoading} type='submit' className='w-[100px] rounded bg-cyan font-bold text-md px-3 py-2'>জমা দিন</button>

                </form>
            </div>
        </div>
    )
};